var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BehaviorSubject } from "rxjs";
import { ToastrService } from "ngx-toastr";
export class SyncService {
    constructor(toastr) {
        this.toastr = toastr;
        this.unsynced$ = new BehaviorSubject(false);
        this.online$ = new BehaviorSubject(window.navigator.onLine);
        window.addEventListener('online', () => this.online$.next(true));
        window.addEventListener('offline', () => this.online$.next(false));
    }
    reset() {
        this.unsynced$.next(false);
    }
    isUnsynced() {
        return this.unsynced$.getValue();
    }
    setDirty(obj) {
        if (obj) {
            obj.isDirty = true;
            obj.isCloudBacked = false;
        }
        this.unsynced$.next(true);
    }
    isOnline() {
        return this.online$.getValue();
    }
    syncWithCloud(userSvc, collectionSvc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isOnline()) {
                return this.toastr.warning("Please connect to the Internet and try again.", "Offline");
            }
            const user = userSvc.user$.getValue();
            if (user) {
                try {
                    yield collectionSvc.sync(false);
                    yield userSvc.sync(!user.isCloudBacked);
                    this.reset();
                }
                catch (err) {
                    console.error(err);
                    return this.toastr.error(err.toString(), 'Sync Failure', { timeOut: 10000 });
                }
            }
            else {
                this.reset();
            }
        });
    }
    getIcon() {
        if (this.isOnline()) {
            return this.isUnsynced()
                ? "glyphicon glyphicon-cloud-upload text-danger text-larger"
                : "glyphicon glyphicon-cloud-download";
        }
        else {
            return this.isUnsynced()
                ? "glyphicon glyphicon-cloud text-danger"
                : "glyphicon glyphicon-cloud text-muted";
        }
    }
}
